import React from 'react';

const EbesSolarPreview = ({ formData }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  };

  const getCompensationModeName = (mode) => {
    const modes = {
      'geracao_junto_carga': 'GERAÇÃO JUNTO À CARGA',
      'autoconsumo_remoto': 'AUTOCONSUMO REMOTO',
      'geracao_compartilhada': 'GERAÇÃO COMPARTILHADA',
      'multiplas_unidades': 'MÚLTIPLAS UNIDADES CONSUMIDORAS'
    };
    return modes[mode] || mode;
  };

  const getPaymentEventName = (event) => {
    const events = {
      'assinatura': 'no ato da assinatura',
      'entrega_modulos': 'na entrega dos módulos',
      'instalacao': 'após instalação',
      'homologacao': 'após homologação'
    };
    return events[event] || event;
  };

  const currentDate = new Date().toLocaleDateString('pt-BR');

  return (
    <div className="bg-white p-6 text-sm leading-relaxed" style={{ minHeight: '800px', fontFamily: 'serif' }}>
      {/* CABEÇALHO */}
      <div className="text-center mb-6 pb-4 border-b-2 border-gray-800">
        <h1 className="text-base font-bold uppercase mb-2">
          CONTRATO DE FORNECIMENTO E INSTALAÇÃO DE
        </h1>
        <h1 className="text-base font-bold uppercase">
          USINA DE MICROGERAÇÃO FOTOVOLTAICA
        </h1>
      </div>

      {/* PARTES */}
      <div className="mb-6 text-justify">
        <p className="mb-3">
          A <strong>EBES ENGENHARIA LTDA - EBES SOLAR</strong>, empresa inscrita no CNPJ/MF sob o n.º 02.277.320/0002-08, 
          com endereço na Av Guajajaras, loja 3, Jardim São Cristovão, CEP 65.056-045 nesta Cidade de São Luis, 
          Estado do Maranhão, neste ato representada pelo Sr. MARCUS VINICIUS MELO CHAVES, doravante denominada 
          <strong> EBES SOLAR</strong> e do outro lado:
        </p>

        <p className="mb-3">
          <strong>{formData.clientName || '[NOME DO CLIENTE]'}</strong>, {formData.clientType === 'pj' ? 'empresa' : 'inscrito(a)'} no {formData.clientType === 'pj' ? 'CNPJ/MF' : 'CPF'} sob o n.º{' '}
          <strong>{formData.clientType === 'pj' ? (formData.clientCNPJ || '[CNPJ]') : (formData.clientCPF || '[CPF]')}</strong>, com endereço à {' '}
          {formData.clientAddress || '[Endereço]'}, {formData.clientCity || '[Cidade]'} - {formData.clientState || '[Estado]'}, 
          CEP: {formData.clientCEP || '[CEP]'}, doravante denominada simplesmente <strong>CLIENTE</strong>,
        </p>

        <p>
          firmam o presente <strong>CONTRATO DE FORNECIMENTO E INSTALAÇÃO DE UMA MICRO USINA FOTOVOLTAICA</strong> 
          (doravante <strong>CONTRATO</strong>), mediante as cláusulas e condições livremente pactuadas nos termos abaixo expostos:
        </p>
      </div>

      {/* CLÁUSULA 1 */}
      <div className="mb-6">
        <h2 className="text-sm font-bold uppercase mb-3 border-b border-gray-600 pb-1">
          CLÁUSULA 1 - DO OBJETO, PREÇO E CONDIÇÕES DE PAGAMENTO
        </h2>
        
        <p className="mb-3 text-justify">
          1.1. É objeto deste contrato o fornecimento e a instalação de uma usina de microgeração fotovoltaica 
          ("USINA"), a ser devidamente conectada à rede elétrica, cuja potência, valor e a respectiva forma e 
          prazo de pagamento encontram-se descritos abaixo:
        </p>

        {/* Tabela de informações */}
        <div className="bg-gray-50 border border-gray-300 p-4 mb-4">
          <h3 className="font-bold text-xs uppercase mb-3">Potência da Usina e Condições de Pagamento:</h3>
          
          <div className="space-y-2 text-xs">
            <div className="flex">
              <span className="w-48 font-semibold">• Potência nominal da Usina:</span>
              <span>{formData.systemPower || '[__]'} kWp</span>
            </div>
            
            <div className="flex">
              <span className="w-48 font-semibold">• Valor total da Usina:</span>
              <span>{formatCurrency(formData.totalValue)}</span>
            </div>
            
            <div className="mt-3">
              <span className="font-semibold">• Forma de pagamento:</span>
              <div className="ml-4 mt-1 space-y-1">
                <div>
                  1ª parcela ({formData.firstPaymentPercent || '50'}%): {formatCurrency(formData.firstPaymentValue)} 
                  {' '}{getPaymentEventName(formData.firstPaymentEvent)}
                </div>
                {formData.firstPaymentPercent < 100 && formData.secondPaymentPercent > 0 && (
                  <div>
                    2ª parcela ({formData.secondPaymentPercent || '50'}%): {formatCurrency(formData.secondPaymentValue)} 
                    {' '}{getPaymentEventName(formData.secondPaymentEvent)}
                  </div>
                )}
              </div>
            </div>

            <div className="flex mt-2">
              <span className="w-48 font-semibold">• Vencimento das parcelas:</span>
              <span>Conforme eventos mencionados</span>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 border border-gray-300 p-4 mb-4">
          <h3 className="font-bold text-xs uppercase mb-3">Informações Adicionais:</h3>
          
          <div className="space-y-2 text-xs">
            <div className="flex">
              <span className="w-48 font-semibold">• Nome do titular da conta:</span>
              <span>{formData.accountHolderName || '[Nome]'}</span>
            </div>
            
            <div className="flex">
              <span className="w-48 font-semibold">• CPF/CNPJ:</span>
              <span>{formData.accountHolderCPF || '[CPF/CNPJ]'}</span>
            </div>
            
            <div className="flex">
              <span className="w-48 font-semibold">• Modalidade:</span>
              <span>{getCompensationModeName(formData.compensationMode)}</span>
            </div>

            <div className="flex">
              <span className="w-48 font-semibold">• Unidades beneficiárias:</span>
              <span>{formData.beneficiaryUnits || '2'} unidade(s)</span>
            </div>
          </div>
        </div>
      </div>

      {/* CLÁUSULA 2 */}
      <div className="mb-6">
        <h2 className="text-sm font-bold uppercase mb-3 border-b border-gray-600 pb-1">
          CLÁUSULA 2 - DO PRAZO DE ENTREGA E DA INSTALAÇÃO
        </h2>
        
        <p className="text-justify text-xs">
          2.1. Fica estabelecido o prazo de <strong>{formData.installationDeadline || '20'} dias úteis</strong> para 
          a instalação da USINA ora contratada, a contar da data da emissão do parecer de acesso.
        </p>
      </div>

      {/* CLÁUSULA 3 */}
      <div className="mb-6">
        <h2 className="text-sm font-bold uppercase mb-3 border-b border-gray-600 pb-1">
          CLÁUSULA 3 - DA GARANTIA
        </h2>
        
        <p className="text-justify text-xs mb-2">
          3.1. A USINA tem garantia de <strong>{formData.warrantyPeriod || '1'} ano</strong> contra defeitos de instalação.
        </p>
        
        <p className="text-justify text-xs">
          3.2. Garantia estendida: <strong>Módulos: {formData.moduleWarranty || '12'} anos</strong> | 
          <strong> Inversores: {formData.inverterWarranty || '10'} anos</strong>
        </p>
      </div>

      {/* CLÁUSULA 4 */}
      <div className="mb-6">
        <h2 className="text-sm font-bold uppercase mb-3 border-b border-gray-600 pb-1">
          CLÁUSULA 4 - DAS DISPOSIÇÕES GERAIS
        </h2>
        
        <p className="text-justify text-xs">
          As partes declaram estar de acordo com todas as cláusulas e condições estabelecidas neste contrato,
          que será regido pelas leis vigentes da República Federativa do Brasil.
        </p>
      </div>

      {/* LOCAL E DATA */}
      <div className="mt-8 text-right italic text-xs">
        {formData.installationCity || '[Cidade]'}, {currentDate}
      </div>

      {/* ASSINATURAS */}
      <div className="mt-12 pt-6 border-t border-gray-400">
        <p className="text-center text-xs italic mb-8">
          E, por estarem justas e contratadas, as partes assinam o presente instrumento.
        </p>
        
        <div className="grid grid-cols-2 gap-8 mt-8">
          <div className="text-center">
            <div className="border-t border-gray-800 pt-2">
              <p className="text-xs font-semibold">EBES ENGENHARIA LTDA</p>
              <p className="text-xs">EBES SOLAR</p>
            </div>
          </div>
          
          <div className="text-center">
            <div className="border-t border-gray-800 pt-2">
              <p className="text-xs font-semibold">{formData.clientName || '[CLIENTE]'}</p>
              <p className="text-xs">CLIENTE</p>
              <p className="text-xs">{formData.clientType === 'pj' ? 'CNPJ' : 'CPF'}: {formData.clientType === 'pj' ? (formData.clientCNPJ || '[CNPJ]') : (formData.clientCPF || '[CPF]')}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Observações */}
      {formData.observations && (
        <div className="mt-6 p-3 bg-yellow-50 border border-yellow-200 rounded">
          <p className="text-xs font-semibold mb-1">Observações:</p>
          <p className="text-xs">{formData.observations}</p>
        </div>
      )}
    </div>
  );
};

export default EbesSolarPreview;